// src/components/WhoWeAre.jsx
import React from 'react';
import '../../styles/components/_section.scss';


import teamImage from '../../images/meet_skiper.jpg'

const WhoWeAre = () => (
  <section className="company-section">
    <img src={teamImage} alt="Hero Dynamics Team" />
    <div className="text-content">
      <h2>About us</h2>
      <p>
At Hero Dynamics, we build the future of underwater exploration. 
Our mission is to develop resilient, intelligent robotic systems that thrive in the planet’s most extreme environments 
gathering data, adapting to challenges, and pushing the limits of what’s possible beneath the surface.
<br /><br />
Our first creation, S.K.I.P.E.R. , is a biomimetic soft-bodied manta ray AUV engineered for exploration in Antarctica’s 
harsh and unpredictable waters. 
Inspired by nature and driven by cutting-edge design, S.K.I.P.E.R. represents our belief that underwater robotics should be as agile and adaptive as the ecosystems they explore. 
While SKIPER is built for polar missions, its robust design and versatility make it ideal for a wide range of underwater applications.
<br /><br />
At Hero Dynamics, we design our technologies not just to survive  but to excel  where others can’t.
<br /><br />
<span style={{ fontWeight: 'bold' }}>Innovation to explore the unknown</span>


  
      </p>
    </div>
  </section>
);

export default WhoWeAre;
